import { autocomplete } from '@algolia/autocomplete-js';
import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions';
import algoliasearch from 'algoliasearch/lite';

import '@algolia/autocomplete-theme-classic';
import { Component, h } from 'preact';

const appId = '4W07DY0SS7';
const apiKey = 'ff94d6a51f9d8d50ec60e1585b033697';
const searchClient = algoliasearch(appId, apiKey);

const querySuggestionsPlugin = createQuerySuggestionsPlugin({
    searchClient,
    indexName: 'faq',
    getSearchParams() {
        return {
            hitsPerPage: 10,
        };
    },
    transformSource({ source, onTapAhead }) {
        return {
            ...source,
            getItemUrl({ item }) {
                return `/helpcenter/question/${item.pretty_url}`;
            },
            templates: {
                ...source.templates,
                item(params) {
                    const { item } = params;
                    return (
                        <a className="aa-ItemLink" href={`/helpcenter/question/${item.pretty_url}`}>
                            <div>
                                <strong>{item.question}</strong>
                                <div>{item.answer}</div>
                            </div>
                        </a>
                    );
                },
            },
        };
    },
});

autocomplete({
    container: '#autocomplete',
    placeholder: 'Search',
    openOnFocus: true,
    plugins: [querySuggestionsPlugin],
});
